import React from "react";
import { MainContainer, InfoMainContainer, InfoContainer, ImageContainer, ImageStyled, LargeButton, MainMessage, CheklistWrapper } from "./styles";
import ErrorImage from "../../assets/hub-reserve-white.png";
import { ROUTES } from '../../routes/constants';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useToasts } from "react-toast-notifications";
import { postUserChangePassword } from "../../services/user/postActions";
import { TextField, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PasswordStrengthBar from "react-password-strength-bar";
import PasswordChecklist from "react-password-checklist";

const RecoverPWD = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email');
    const token = queryParams.get('token');

    const [userPwd, setUserPwd] = React.useState("");
    const [userVerPwd, setUserVerPwd] = React.useState("");
    const [showPassword, setShowPassword] = React.useState(false);
    const [showVerPassword, setShowVerPassword] = React.useState(false);

    const navigate = useNavigate();
    const { addToast } = useToasts();

    React.useEffect(() => {
        if (!email || !token) {
            navigate(`${ROUTES.ERROR}`)
        }
    }, [])

    // ------------------- PASSWORD HANDLERs -------------------
    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const toggleShowVerPassword = () => {
        setShowVerPassword(!showVerPassword);
    };

    const recoverPassword = async () => {
        // ------------------- REQUIREMENTS VALIDATION -------------------
        const passwordValidationRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#+$%^&*.])/;
        const passwordValidation = passwordValidationRegex.test(userPwd);
        if (!passwordValidation) {
            addToast("La contraseña no es segura", {
                appearance: "error",
                autoDismiss: true,
            });
            return;
        } else if (userPwd.length < 8) {
            addToast("La contraseña debe tener al menos 8 caracteres", {
                appearance: "error",
                autoDismiss: true,
            });
            return;
        } else if (userPwd !== userVerPwd) {
            addToast("Las contraseñas no coinciden", {
                appearance: "error",
                autoDismiss: true,
            });
            return;
        }

        await postUserChangePassword(email!, token!, userPwd)
            .then((res: any) => {
                if (res && res.data && res.status < 300) {
                    addToast("La contraseña se ha modificado correctamente", {
                        appearance: "success",
                        autoDismiss: true,
                    });
                    navigate(`${ROUTES.LOGIN}`);
                } else {
                    addToast("Ocurrió un error al modificar su contraseña", {
                        appearance: "error",
                        autoDismiss: true,
                    });
                }
            })
            .catch((err: any) => {
                console.error(err);
            });
    }

    return (
        <>
            <MainContainer>
                <InfoMainContainer>
                    <InfoContainer>
                        <MainMessage>Recuperar contraseña</MainMessage>
                        <TextField
                            label="Contraseña"
                            type={showPassword ? "text" : "password"}
                            variant="outlined"
                            value={userPwd}
                            onChange={(event) => setUserPwd(event.target.value)}
                            fullWidth
                            required
                            sx={{ margin: "15px 0" }}
                            InputProps={{
                                style: {
                                    borderRadius: "14px",
                                },
                                endAdornment: (
                                    <IconButton
                                        onClick={toggleShowPassword}
                                        sx={{
                                            minWidth: 0,
                                            borderRadius: "30px",
                                            background: "transparent",
                                        }}
                                    >
                                        {showPassword ? (
                                            <Visibility style={{ color: "A9A9A9" }} />
                                        ) : (
                                            <VisibilityOff style={{ color: "A9A9A9" }} />
                                        )}
                                    </IconButton>
                                ),
                            }}
                        />
                        <PasswordStrengthBar
                            password={userPwd}
                            scoreWords={["Muy débil", "Débil", "Okay", "Buena", "Fuerte"]}
                            shortScoreWord={"Muy corta"}
                        />

                        <TextField
                            label="Contraseña (confirmación)"
                            type={showVerPassword ? "text" : "password"}
                            variant="outlined"
                            value={userVerPwd}
                            onChange={(event) => setUserVerPwd(event.target.value)}
                            fullWidth
                            required
                            sx={{ margin: "15px 0" }}
                            InputProps={{
                                style: {
                                    borderRadius: "14px",
                                },
                                endAdornment: (
                                    <IconButton
                                        onClick={toggleShowVerPassword}
                                        sx={{
                                            minWidth: 0,
                                            borderRadius: "30px",
                                            background: "transparent",
                                        }}
                                    >
                                        {showVerPassword ? (
                                            <Visibility style={{ color: "A9A9A9" }} />
                                        ) : (
                                            <VisibilityOff style={{ color: "A9A9A9" }} />
                                        )}
                                    </IconButton>
                                ),
                            }}
                        />

                        <CheklistWrapper>
                            <PasswordChecklist
                                rules={[
                                    "minLength",
                                    "specialChar",
                                    "number",
                                    "capital",
                                    "match",
                                ]}
                                minLength={5}
                                value={userPwd}
                                valueAgain={userVerPwd}
                                messages={{
                                    minLength: "La contraseña tiene más de 8 caracteres.",
                                    specialChar:
                                        "La contraseña tiene al menos un caracter especial.",
                                    number: "La contraseña tiene al menos un número.",
                                    capital:
                                        "La contraseña tiene al menos una letra mayúscula.",
                                    match: "Las contraseñas coinciden.",
                                }}
                            />
                        </CheklistWrapper>
                    </InfoContainer>

                    <LargeButton onClick={recoverPassword}
                    >Confirmar</LargeButton>
                </InfoMainContainer>

                <ImageContainer>
                    <ImageStyled src={ErrorImage} alt="Activate icon"></ImageStyled>
                </ImageContainer>
            </MainContainer>
        </>
    );
}

export default RecoverPWD;